const funcion = {
  DescargarArchivo: 'Comun/Funciones/DescargaArchivo',
  ObtenerPdf: 'Comun/Funciones/ObtenerPdfV2',
  ConvertirAPdf: 'Comun/Funciones/ConvertirAPdfV2',
  ConvertirAPdf3: 'Comun/Funciones/ObtenerPdfV3',
  ObtenerPdfConMarcaDeAgua: 'Comun/Funciones/ObtenerPdfConMarcaDeAgua'
}

export default funcion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/comun/funcion/funcion.js
// module id = KXn1
// module chunks = 2